import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klpkonsern/routing';
import { getConfig } from '@klpkonsern/appconfig';
import type { Bruker } from '@klp/user';

export const ContractManagementModuleName = 'contractmanagement';
export const RegistrationRoute = 'registration';
export const DetailsRoute = 'details';
export const AssignResponsibleRoute = 'assign';
export const ShareDocumentRoute = 'share';

export enum ContractManagementTabs {
    registrering = RegistrationRoute,
    levendekontrakter = 'dynamicnegotiation',
    signering = 'signing',
    forhandling = 'negotiations',
    avtaler = 'deals',
}

export const ContractManagementAccess = (user: Bruker | undefined): boolean =>
    Boolean(getConfig('WEBAPP_CONTRACTMANAGEMENT_ENABLE') && user?.isAdmin);

export const ContractManagementRegistrationAccess = (): boolean =>
    getConfig('WEBAPP_CONTRACTMANAGEMENT_REGISTRATION_ENABLE') || false;

export const ContractManagementRoutes = {
    moduleRoute: () => generateRoute([ContractManagementModuleName]),
    tab: (tab?: ContractManagementTabs | ':tab') =>
        generateRoute([ContractManagementModuleName, tab]),
};

export const ContractRegistrationRoutes = {
    moduleRoute: (kontraktId?: string) =>
        generateRoute([
            ContractManagementRoutes.tab(ContractManagementTabs.registrering),
            kontraktId,
        ]),
    single: (dokumentId?: string) =>
        generateRoute([
            ContractManagementRoutes.tab(ContractManagementTabs.registrering),
            dokumentId,
        ]),
    singleOld: (dokumentId?: string) =>
        generateRoute([ContractManagementModuleName, DetailsRoute, dokumentId]),
    singleInstance: (dokumentId?: string, prosessInstansId?: string) =>
        generateRoute([
            ContractManagementRoutes.tab(ContractManagementTabs.registrering),
            dokumentId,
            prosessInstansId,
        ]),
    assignResponsible: (dokumentId?: string) =>
        generateRoute([
            ContractManagementModuleName,
            AssignResponsibleRoute,
            dokumentId,
        ]),
    shareDocument: (dokumentId?: string) => {
        return generateRoute([
            ContractManagementModuleName,
            ShareDocumentRoute,
            dokumentId,
        ]);
    },
};

export const ContractManagementMenuItems = [
    new SidebarMenuItem({
        route: ContractManagementRoutes.moduleRoute(),
        matchRoute: ContractManagementRoutes.moduleRoute(),
        icon: IconName.DOCUMENTS,
        translation: 'contractManagement.title',
        access: ContractManagementAccess,
    }),
];

export const ClientRoutes = {
    byggView: (kundeNummer?: string, byggNummer?: string) =>
        generateRoute(['client', kundeNummer, 'eiendom', byggNummer]),
    byggListView: (kundeNummer?: string) =>
        generateRoute(['client', kundeNummer, 'eiendom']),
};
